/**
 * @file        src/pages/hotel/CorporateSearchLog.jsx
 * @description Corporate Hotel → Search Log. Same list as the B2C Hotel Search
 *              Log (SearchLog.jsx), fixed to audience=b2b, instead of forking
 *              the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Hotel menu parity with B2C).
 */
import SearchLog from './SearchLog';

export default function CorporateSearchLog() {
  return (
    <SearchLog
      title="Corporate Search Log"
      subtitle="Corporate Hotel · B2B customer searches"
      audience="b2b"
    />
  );
}
